<template>
  <div class="container-fluid m-0 p-0">
    <div class="row bg-light text-left border-top border-bottom py-2 ml-1">
      <div class="col-sm-12 h-100 my-auto p-0 m-0">
        <span class="mx-3 font-weight-bold lead">Per Document Monitoring</span>
        <span class="mx-3">
<!--          <button class="btn btn-sm btn-outline-primary font-weight-bolder"-->
          <!--                  data-toggle="modal"-->
          <!--                  data-target="#add-document"-->
          <!--          >-->
          <!--            <span class="fas fa-plus"></span>-->
          <!--            Add Document-->
          <!--          </button>-->
        </span>
        <span class="float-right py-1 mx-2 pr-4">
          <button class="btn btn-xs btn-outline-secondary px-2 mr-1" title="Go to Previous Page"
                  @click="goBack"
          >
            <span class="fas fa-backward"></span>
            Go Back
          </button>
        </span>
      </div>
    </div>

    <div class="row text-small pt-3">
      <div class="col col-md-12" style="min-height: 450px !important;">
        <div class="form-group form-inline">
          <div class="form-group">
          <label v-if="this.isPrincipal && getManningLists.length > 1"
                 for="manning" class="pr-3 font-weight-bold ml-3 mt-3">
            Manning:
          </label>
          <select id="manning"
                  v-if="this.isPrincipal && getManningLists.length > 1"
                  class="form-control form-control-xs input-group-append mt-3"
                  v-model="params.manning"
                  @change="handleVesselChange">
            <option :value="null">ALL MANNING</option>
            <option v-for="manningKey in getManningLists"
                    :key="manningKey.id"
                    :title="manningKey.name"
                    :value="manningKey.id">
              {{ manningKey.alias }}
            </option>
          </select>
          </div>
          <div class="form-group">
          <label for="vessel" class="pr-3 font-weight-bold ml-3 mt-3">Vessel: </label>
          <select id="vessel"
                  class="form-control form-control-xs input-group-append mt-3"
                  v-model="params.vessel"
                  @change="setPage(1)">
            <option :value="null">ALL VESSEL</option>
            <option v-for="vessel in vesselKeys" :key="vessel.id" :value="vessel.id">
              {{ vessel.name }}
            </option>
          </select>
          </div>
          <label for="nationality" class="pr-3 font-weight-bold ml-3 mt-3">Nationality: </label>
          <select id="nationality"
                  class="form-control form-control-xs input-group-append  mt-3"
                  v-model="params.nationality"
                  @change="setPage(0)">
            <option :value="null">ALL NATIONALITY</option>
            <option v-for="natlKey in natlKeys"
                    :key="natlKey.id"
                    :value="natlKey.id"
                    :title="natlKey.natl"
            >{{ natlKey.natl }}
            </option>
          </select>
          <div class="form-group">
          <label for="rank" class="pr-3 font-weight-bold ml-3 mt-3">Rank: </label>
          <select id="rank"
                  class="form-control form-control-xs input-group-append mt-3"
                  v-model="params.rank"
                  @change="setPage(1)"
          >
            <option :value="null">ALL RANKS</option>
            <option  value="do">DECK OFFICERS</option>
            <option  value="dr">DECK RATINGS</option>
            <option  value="eo">ENGINE OFFICERS</option>
            <option  value="er">ENGINE RATINGS</option>
            <option  value="stwrd">STEWARD </option>
            <option v-for="rankKey in rankObjKeys"
                    :key="rankKey.id"
                    :title="rankKey.name"
                    :value="rankKey.id"
            >{{ rankKey.alias }}
            </option>
          </select>
          </div>
          <div class="form-group">
          <label for="activityCode" class="pr-3 font-weight-bold ml-3 mt-3">Activity Status: </label>
          <select id="activityCode" class="form-control form-control-xs input-group-append mt-3"
                  v-model="params.activity_status"
                  @change="setPage(1)"
          >
            <option :value="null">ALL ACTIVITY STATUSES</option>
            <option v-for="activityCodeKey in activityCodeKeys"
                    :key="activityCodeKey.id"
                    :value="activityCodeKey.id"
                    :title="activityCodeKey.name">{{ activityCodeKey.name }}
            </option>
          </select>
          </div>
          <div class="form-group">
          <label for="status" class="pr-3 font-weight-bold ml-3 mt-3">Account Status: </label>
          <select id="status" class="form-control form-control-xs input-group-append mt-3"
                  v-model="params.crew_status"
                  @change="setPage(1)"
          >
            <option :value="null">ALL ACCOUNT STATUSES</option>
            <option :value="1">ACTIVE</option>
            <option :value="0">INACTIVE</option>
          </select>
          </div>
        </div>
        <div class="form-group form-inline">
          <div class=" col-md-2 form-group mt-2">
            <Multiselect :options="JISSdocuments"
                         v-model="selectedDocument"
                         @input="handleDocumentChange"
                         :multiple="true"
                         :close-on-select="false"
                         :clear-on-select="false"
                         :preserve-search="true"
                         label="name"
                         track-by="id"
                         size="sm"
                         :preselect-first="false"
                         class="custom-multiselect "
                         placeholder="Select Document">

            </Multiselect>
          </div>
          <div class="col-md-4 input-group form-inline">
            <label for="dateFrom" class="form-control-xs font-weight-bold mr-1">
              From:
            </label>
            <input type="date"
                   id="date-from"
                   class="form-control form-control-xs"
                   v-model="params.expiry_from"
                   @input="setPage(1)">

            <label for="dateTo" class="form-control-xs font-weight-bold ml-3 mr-1">
              To:
            </label>
            <input type="date" id="date-to"
                   class="form-control form-control-xs"
                   v-model="params.expiry_to"
                   @input="setPage(1)"
            >
          </div>
          <div class="col-md-4 input-group form-inline mt-2" style="width: 20% !important;">
          </div>
        </div>
        <div class="form-group form-inline">
          <div class="ml-auto">
            <button v-if="!isLoading" id="generateReportPDF"
                    :disabled="Object.values(params).every(value => value === null)"
                    class="btn btn-danger btn-xs p-1 mr-1"
                    @click="generateDocumentMonitoringPDF">
              <i class="fas fa-file-pdf fa-2x mx-1"></i>
              Generate as PDF
            </button>
            <button v-if="!loadingPdf" id="generateReportPDF"
                    :disabled="Object.values(params).every(value => value === null)"
                    class="btn btn-success btn-xs p-1"
                    @click="generateDocumentMonitoringExcel">
              <i class="fas fa-file-excel fa-2x mx-1"></i>
              Generate as Excel
            </button>
          </div>
        </div>
        <div v-if="isLoading">
          <app-loading></app-loading>
        </div>
        <div class="col col-12" v-else>
          <div class="mt-3" id="jissReport">
          <div class="table-container">
          <table class="table table-bordered table-sm text-small">
            <thead>
              <tr>
                  <th colspan="2" rowspan="2" class="freeze-col freeze-col-1">No</th>
                  <th colspan="2" rowspan="2" class="freeze-col freeze-col-2">Present Rank</th>
                  <th colspan="2" rowspan="2" class="freeze-col freeze-col-3">Name</th>
                  <th colspan="2" rowspan="2">Birthdate</th>
                  <th colspan="2" rowspan="2">Age (Auto)</th>
                  <th colspan="2" rowspan="2">STATUS</th>
                  <th :style="{'background-color': '#'+column.color}" :colspan="column.sub_cols.length" v-for="(column,index) in jissDocumentColumn" :key="index">
                    {{column.name}}
                  </th>
              </tr>
              <tr>
                  <template v-for="column in jissDocumentColumn">
                    <th :style="{'background-color': '#'+column.sub_col_color}" v-for="(sub_col,index) in column.sub_cols" :key="column.name+index">
                      {{sub_col}}
                    </th>
                  </template>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(crewDocument,index) in jissDocumentMonitoring.data" :key="crewDocument.id">
                <td colspan="2" class="freeze-col freeze-col-1">{{ index + pagination.from }}</td>
                <td class="text-center freeze-col freeze-col-2" colspan="2" >{{crewDocument.rank}}</td>
                <td v-tooltip="crewDocument" data-html="true"  colspan="2" class="freeze-col freeze-col-3">
                  {{crewDocument.last_name}}, {{crewDocument.first_name}} {{crewDocument.middle_name ? crewDocument.middle_name.substring(0,1) + '.' : ''}}
                </td>
                <td colspan="2">{{crewDocument.birthdate}}</td>
                <td class="text-center" colspan="2">{{crewDocument.age}}</td>
                <td class="text-center" colspan="2">{{crewDocument.status}}</td>
                <template v-for="column in jissDocumentColumn">
                  <!-- eslint-disable-next-line vue/no-unused-vars -->
                  <template v-for="sub_col in column.sub_cols" >
                    <!-- eslint-disable-next-line vue/require-v-for-key -->
                      <td v-if="  sub_col.toLowerCase() === 'expiry'" :style="{
                        'background-color': getValueFromDocument(crewDocument.documents,column.name,'expiry_date_color').background,
                        'color':getValueFromDocument(crewDocument.documents,column.name,'expiry_date_color').color,
                      }">
                        {{getValueFromDocument(crewDocument.documents,column.name,sub_col)}}
                      </td>
                    <!-- eslint-disable-next-line vue/require-v-for-key -->
                      <td v-else>
                        {{getValueFromDocument(crewDocument.documents,column.name,sub_col)}}
                      </td>
                  </template>
                </template>
              </tr>
            </tbody>
          </table>
          </div>
          </div>
        </div>
      </div>

      <nav aria-label="..." class="ml-3 pt-2">
        <ul class="pagination text-smallest">
          <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
            <button class="page-link" @click="setPage(1)">First</button>
          </li>

          <li v-for="page in paginationPages" :key="page" class="page-item"
              :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
            <button class="page-link" @click="setPage(page)">{{ page }}</button>
          </li>

          <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
            <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
          </li>
        </ul>
      </nav>

    </div>

  </div>
</template>

<script>

import {mapActions, mapGetters} from 'vuex';
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {gateMixin} from "@/mixins/gateMixin";
import {paginationMixin} from "@/mixins/paginationMixin";
import appLoading from "@/components/elements/AppLoading.vue";
import {ReportService} from "@/services/ReportService";
import {debounce} from "lodash";
import Multiselect from 'vue-multiselect'
import jissTooltipDirective from "../../../../directives/jiss-tooltip-directive";

export default {
  name: "GeneratePerDocumentMonitoring",

  mixins: [vueAppMixin, paginationMixin, gateMixin],

  components: {appLoading,Multiselect},
  directives:{
    tooltip:jissTooltipDirective
  },
  data() {
    return {
      JISSdocuments: [
        {id: 10, name: "PH COC"},
        {id: 17, name: "JCOC"},
        {id: 22, name: "THIRD GRADE LICENSE"},
        {id: 18, name: "ORANGE BOOK"},
        {id: 178, name: "V3 CERTIFICATE (BASIC)"},
        {id: 177, name: "V3 CERTIFICATE (ADVANCED)"},
        {id: 20, name: "GOC"},
        {id: 32, name: "GOC BOOKLET"},
        {id: 21, name: "ROC"},
        {id: 23, name: "HEALTH SUPERVISOR"},
        {id: 73, name: "SSO"},
        {id: 19, name: "SSO TRAINING CERTIFICATE"},

      ],
      perPageOptions: [
        // { label: '10', value: 10 },
        {label: '20', value: 20},
        {label: '30', value: 30},
        {label: '40', value: 40},
        {label: '50', value: 50},
        {label: '60', value: 60},
        {label: '70', value: 70},
        {label: '80', value: 80},
        {label: '90', value: 90},
        {label: '100', value: 100},
      ],
      params: {
        page: 1,
        isJiss:true,
        document:null,
        manning:null,
        vessel:null,
        rank:null,
        activity_status:null,
        nationality:1,
        crew_status:1
      },
      selectedDocument:[],
      loadingPdf:false,
      isHoverColumnCrewName: false,
      isHoverColumnDocumentDateExpiry: false
    }
  },

  methods: {
    ...mapActions([
      'getJissDocumentMonitoring',
      'getActivityCodeKeys',
      'getDocumentTypeKeys',
      'getNatlKeys',
      'getManningKeys',
      'getVesselKeys',
      'getRankObjKeys',
      'addDocument',
      'getJissDocumentColumn'
    ]),


    async generateDocumentMonitoringPDF() {
      let params = {};
      Object.keys(this.params).forEach(key=>{
        if(!['perPage','page'].includes(key)){
          params[key]=this.params[key]
        }
      })
      await ReportService.generateJISSPERDocumentMonitoringPDF(this.params);
    },

    async generateDocumentMonitoringExcel() {
      let params = {};
      Object.keys(this.params).forEach(key=>{
        if(!['perPage','page'].includes(key)){
          params[key]=this.params[key]
        }
      })
      await ReportService.generateJISSPERDocumentMonitoringExcel(params);
    },
    async initializeData() {

      this.getDocumentTypeKeys();
      this.getRankObjKeys();
      this.getVesselKeys();
      this.getManningKeys();
      this.getNatlKeys();
      this.getActivityCodeKeys();
      // this.getDocumentMonitoring(this.params);
      this.getJissDocumentColumn()
    },

    getDocumentByName(document,name=''){
      return document.filter(item=>item.name === name)[0];
    },

    getValueFromDocument(document,name='',key=''){
        const value = this.getDocumentByName(document,name)
        let keyEquivalent = null;
        switch (key.toLowerCase()){
          case 'capacity':
             keyEquivalent = 'capacity_rank';
             break;
          case 'expiry':
            keyEquivalent = 'expiry_date';
            break;
          case 'year issued':
          case 'issue date':
          case 'booklet issue date':
            keyEquivalent = 'issued_date';
            break;
          case 'booklet no.':
          case 'no':
            keyEquivalent = 'doc_no';
            break;
          default:
            keyEquivalent = key;
            break;
        }
        if(keyEquivalent === null) {
          return value;
        }
        return value[keyEquivalent] ?? null;
    },
    updateVesselKeys() {
      if (this.isOchg || !this.isSystemAdmin || this.isKobe) {
        let previousVesselId = this.params.vesselId;
        this.params.vesselId = null;
        let vesselParams = {
          manningId: this.params.manningId
        };
        this.getVesselKeys(vesselParams);

        if (previousVesselId !== null) {
          this.params.vesselId = previousVesselId;
        }
      }

    },
    handleDocumentChange() {
      this.params.document=this.selectedDocument.map(item => item.id)
      const params = this.params.document ? {document:this.params.document} : {}
      this.getJissDocumentColumn(params)
      this.setPage(1);
    },

    handleVesselChange() {
      this.params.vesselId = null;
      this.setPage(1);
    },

    updateRankKeys() {
      let previousRankId = this.params.documentIds;
      let previousWatchKeepingStamp = this.params.isWatchKeepingStamp;

      let documentParams = {
        documentId: this.params.documentIds,
        isWatchKeepingStamp: this.params.isWatchKeepingStamp
      };

      this.getRankObjKeys(documentParams);

      if (previousRankId !== null || previousWatchKeepingStamp !== null) {
        this.params.documentIds = previousRankId;
        this.params.isWatchKeepingStamp = previousWatchKeepingStamp;
      }
    },
    debouncedSearch: debounce(function () {
      this.searchDocumentMonitoring();
    }, 500),
    sortTable(column) {
      if (this.params.sortColumn === column) {
        if (this.params.sortOrder === 'asc') {
          this.params.sortOrder = 'desc';
        } else if (this.params.sortOrder === 'desc') {
          this.params.sortOrder = null;
          this.params.sortColumn = null;
        } else {
          this.params.sortOrder = 'asc';
        }
      } else {
        this.params.sortColumn = column;
        this.params.sortOrder = 'asc';
      }
      this.searchDocumentMonitoring();
      this.setPage(1);
    },
    searchDocumentMonitoring() {
      this.params.page=this.pagination.currentPage
      this.getJissDocumentMonitoring(this.params);
    },
    setPage(page) {
      this.pagination.currentPage = page;
      this.searchDocumentMonitoring();
    },


  },

  computed: {
    ...mapGetters([
      'rankObjKeys',
      'natlKeys',
      'vesselKeys',
      'manningKeys',
      'jissDocumentMonitoring',
      'activityCodeKeys',
      'jissDocumentColumn'
    ]),


    getManningLists(){
      return this.manningKeys.filter((manning)=>{
        return this.isKline ? ![7,17].includes(manning.id) : true
      })
    }
  },

  created() {
    this.initializeData();
    if (this.user.manning_id) {
      this.manning = this.user.manning_id;
    } else {
      // this.manning = this.manningId;
      this.manning = 0;
    }
    this.$store.commit('SET_IS_LOADING',false)
    this.$store.commit('SET_DOCUMENT_MONITORING',[])
  },

};
</script>

<style scoped>
#jissReport .table-container {
  max-height: 600px;
  overflow: auto;
  position: relative;
  text-transform: uppercase;
}
#jissReport table {
  border-collapse: separate;
  border-spacing: 0;
  width: max-content; /* to avoid collapsing columns */
  min-width: 100%;
}

#jissReport thead th {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 2;
}

#jissReport .freeze-col {
  position: sticky;
  background: white;
  z-index: 5;
}

#jissReport thead .freeze-col-1,
#jissReport thead .freeze-col-2,
#jissReport thead .freeze-col-3,
#jissReport thead .freeze-col-4,
#jissReport thead .freeze-col-5{
  position: sticky;
  top: 0;
  z-index: 5;
}
#jissReport .freeze-col-1 {
  left: 0;
  z-index: 20;
  min-width: 32px;
}
#jissReport .freeze-col-2 {
  left: 32px;
  z-index: 20;
  min-width: 50px;
}
#jissReport .freeze-col-3 {
  left: 147px;
  z-index: 20;
  min-width: 50px;
}
#jissReport .freeze-col-4 {
  left: 320px;
  z-index: 20;
  min-width: 50px;
}
#jissReport .freeze-col-5 {
  left:  415px;
  z-index: 20;
  min-width: 50px;
}

.custom-multiselect ::v-deep .multiselect__tags {
  max-height: 100px;
  overflow-y: auto;
}
.tooltip .tooltip-inner {
  max-width: 400px; /* default is 200px, increase as needed */
  white-space: normal;
  line-height: 1.6; /* more space between lines */
  padding: 10px 25px;
  font-size: 14px;
  border-radius: 8px; /* optional: round corners */
  text-align: left !important; /* ✅ Fix alignment */
}
.tooltip .tooltip-inner ul {
  margin: 0;
  padding-left: 1.2em; /* keep indentation for bullets */
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>